import React from "react";
import styled from "styled-components";

export default styled.div`
    width: 100%;
    background: white;
    padding-top: 56.2%;
    position: relative;
`;